import authService from "../../../services/auth.service";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

function SignOut() {
    const navigate = useNavigate();

    useEffect(()=>{
        authService.logout();
        navigate("/authentication/login");
    }, [navigate]);

    return (<p>GoodBy3</p>)
}

export default SignOut;
